const MoldOrderDetailSkeleton = () => {
  return (
    <div className="w-full px-4 py-2 sm:p-4">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-4 sm:p-6">
          {/* Header Section */}
          <div className="space-y-4 sm:space-y-0 sm:flex sm:justify-between sm:items-start sm:gap-4 mb-4 sm:mb-6">
            <div className="w-full">
              {/* Title skeleton */}
              <div className="h-7 w-3/4 bg-gray-200 rounded-md animate-pulse mb-2 sm:mb-3" />
              <div className="flex flex-wrap gap-2">
                <div className="h-6 w-24 bg-blue-100 rounded-full animate-pulse" />
                <div className="h-6 w-32 bg-gray-200 rounded-full animate-pulse" />
                <div className="h-6 w-24 bg-gray-200 rounded-full animate-pulse" />
              </div>
            </div>
            {/* Countdown skeleton */}
            <div className="w-full sm:w-auto shrink-0">
              <div className="h-20 w-48 bg-gray-200 rounded-lg animate-pulse" />
            </div>
          </div>

          <div className="space-y-4 lg:space-y-0 lg:flex lg:gap-6">
            <div className="flex-auto w-2/3">
              {/* Info Section */}
              <div className="bg-gray-50 rounded-lg mb-3 sm:mb-4">
                <div className="divide-y divide-gray-200">
                  {[...Array(5)].map((_, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-2 sm:grid-cols-[200px_1fr] items-center gap-1 py-1.5 sm:py-2 px-3 sm:px-4"
                    >
                      <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                      <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
                    </div>
                  ))}
                </div>
              </div>

              {/* Note Section Skeleton */}
              <div className="mb-3 sm:mb-4">
                <div className="h-4 w-48 bg-gray-200 rounded animate-pulse mb-1" />
                <div className="h-16 bg-gray-100 rounded-md animate-pulse" />
              </div>
            </div>

            {/* Action Box Skeleton */}
            <div className="w-full lg:w-80 bg-gray-50 rounded-lg p-4">
              <div className="space-y-4">
                <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" />
                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                <div className="h-24 bg-gray-200 rounded animate-pulse" />
              </div>
            </div>
          </div>

          {/* Progress Section */}
          <div className="mt-3 sm:mt-6">
            <div className="h-6 w-32 bg-gray-200 rounded animate-pulse mb-4" />
            <div className="relative">
              <div className="overflow-x-auto pb-4 -mx-4 px-4 sm:mx-0 sm:px-0">
                <div className="min-w-[800px] h-24 bg-gray-100 rounded-lg animate-pulse" />
              </div>
              <div className="block sm:hidden h-4 w-48 bg-gray-200 rounded animate-pulse mt-2 mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoldOrderDetailSkeleton;
